/** Whether the client will accept a payment plan from the debtor. */
export const PAYMENT_PLAN_HINT =
  'A payment plan lets the debtor pay the full amount over time. The amount owed stays the same. No means the attorney should collect it at once. Yes means they may agree to a plan. A payment for part of the bill can still be recorded, and the rest stays owed.';

export const DEBTOR_INSTALLMENT_PLANS = Object.freeze([
  {
    value: 'NO',
    label: 'No',
    description: 'You will not accept a payment plan; the debtor must pay in full.',
    paymentStructure: 'FULL',
  },
  {
    value: 'YES',
    label: 'Yes',
    description: 'You are willing to accept a payment plan from the debtor.',
    paymentStructure: 'INSTALLMENT_PLAN',
  },
]);

const LEGACY_YES = new Set([
  'YES',
  'INSTALLMENTS_2',
  'INSTALLMENTS_3',
  'INSTALLMENTS_4',
  'INSTALLMENTS_6',
  'PAYMENT_TERM',
  'INSTALLMENT_PLAN',
]);

const LEGACY_NO = new Set(['NO', 'FULL', '']);

export function normalizePaymentPlanChoice(value) {
  const raw = String(value || '').trim();
  if (!raw || LEGACY_NO.has(raw)) return 'NO';
  if (LEGACY_YES.has(raw) || raw.startsWith('TERM:')) return 'YES';
  if (raw === 'YES' || raw === 'NO') return raw;
  return 'NO';
}

export function installmentPlanLabel(value) {
  const choice = normalizePaymentPlanChoice(value);
  return DEBTOR_INSTALLMENT_PLANS.find((p) => p.value === choice)?.label || choice || '—';
}

export function paymentStructureForPlan(value) {
  const choice = normalizePaymentPlanChoice(value);
  return (
    DEBTOR_INSTALLMENT_PLANS.find((p) => p.value === choice)?.paymentStructure || 'FULL'
  );
}

/** Build Yes/No select options for the payment-plan acceptance field. */
export function buildInstallmentPlanOptions(_paymentTerms = []) {
  return DEBTOR_INSTALLMENT_PLANS.map((plan) => ({
    value: plan.value,
    label: plan.label,
    description: plan.description,
    kind: 'preset',
  }));
}

export function parseInstallmentSelection(value) {
  const choice = normalizePaymentPlanChoice(value);
  return {
    installmentPlan: choice,
    paymentTermId: null,
    paymentStructure: paymentStructureForPlan(choice),
  };
}

export function selectionFromMatter(matter) {
  const plan = String(matter?.Installment_Plan || '').trim();
  if (plan === 'PAYMENT_TERM' || matter?.Payment_Term_ID) {
    // Legacy saved payment-term selections imply the client accepted a plan.
    return 'YES';
  }
  return normalizePaymentPlanChoice(plan);
}
